import React from "react";
import { actions } from "./../store/Distance";
import { ApplicationState } from "./../store";
import { connect, ConnectedProps } from "react-redux";
import { RadioButtonGroupBase } from "./RadioButtonGroupBase";
import { makeStyles, Typography } from "@material-ui/core";
import Theme from "../.themes/common/Theme";

const useStyles = makeStyles((theme: Theme) => ({
  mileageText: {
    color: theme.mileageInfoBox?.textColor ?? theme.palette?.primary?.main,
    backgroundColor: theme.mileageInfoBox?.backgroundColor ?? theme?.palette?.info.light,
    fontWeight: theme.mileageInfoBox?.fontWeight ?? 400,
    padding: 24,
    fontSize: "1rem",
    lineHeight: "24px",
  },
}));

export const DistanceSelector: React.FC<DistanceProps> = (props: DistanceProps) => {
  const classes = useStyles();
  if (props.showMileageTextForTaxi) {
    return <Typography className={classes.mileageText}>{props.mileageTextTaxi}</Typography>;
  }

  return (
    <RadioButtonGroupBase
      label={{ title: props.label?.title }}
      help={props.help}
      selected={props.selected}
      onChange={props.distanceChanged}
      id='distanceSelector'
      values={props.values?.map(i => ({
        value: i.value,
        title: i.title,
      }))}
    />
  );
};

const connector = connect((state: ApplicationState) => state.distance, {
  distanceChanged: actions.distanceChanged,
});

type DistanceProps = ConnectedProps<typeof connector> & {};

export default connector(DistanceSelector);
